import { guardNull } from "../misc/guard-null";
import { guardNumber } from "../numbers";
import type { CalculationFormPositionItem } from "../schemas";
import { generateId } from "../strings";
import type { ServerSet, Tables } from "../types";

/**
 * Prepares a single named position for persistence under its parent service item.
 *
 * @param position - The form position to prepare.
 * @param serviceCalculationItemId - The service item this position belongs to.
 * @returns The row shape ready to upsert into `serviceCalculationItemPositions`.
 */
export function prepareCalculationItemPosition(
	position: CalculationFormPositionItem,
	serviceCalculationItemId: string,
): ServerSet<Tables<"serviceCalculationItemPositions">> {
	return {
		id: guardNull(position.id) || generateId(),
		serviceCalculationItemId,
		name: guardNull(position.name),
		ranking: guardNumber(position.ranking),
		quantity: guardNull(position.quantity),
		length: guardNull(position.length),
		width: guardNull(position.width),
		height: guardNull(position.height),
		meters: guardNull(position.meters),
		manualMeasurement: guardNull(position.manualMeasurement),
		// `sum` backed the now-removed manual-sum feature; the column still exists but nothing
		// writes to it anymore.
		sum: null,
	};
}
